export const checkIsNumber = (value: unknown) => {
  return typeof Number(value) === "number" && !Number.isNaN(Number(value));
};
